export default {
  boleto: 'payment-method.boleto',
  credit_card: 'payment-method.credit-card',
  bank_transfer: 'payment-method.bank-transfer',
  debit: 'payment-method.debit',
  debit_card: 'payment-method.debit',
  private_label: 'payment-method.private-label',
  cash: 'payment-method.cash',
  safety_pay: 'payment-method.safety-pay',
  voucher: 'payment-method.voucher',
  pix: 'payment-method.pix',
  others: 'payment-method.others'
}
